import React, { FC } from 'react';
import { Badge, Button, Radio } from '@kontentino/ui';
import Link from 'components/shared/Link';
import { PostPublishingMethod } from 'types/Post';
import { IGPostPublishingMethodUtils } from 'app/modules/posts/modules/post/constants/instagramPublishingMethodsProperties';
import { PseudoPostType } from 'constants/post';
import { useTranslation } from 'react-i18next';
import { PseudoPostTypesUtils } from 'app/modules/posts/utils/pseudoPostType';

type Props = {
  value?: PostPublishingMethod;
  onChange: (value: PostPublishingMethod) => void;
  pseudoType: PseudoPostType;
  disabledMethods?: PostPublishingMethod[];
};

const PostComposerPublishingMethodInstagram: FC<Props> = (props) => {
  const { t } = useTranslation();
  const publishingMethods = IGPostPublishingMethodUtils.getOptionsEntries(
    props.pseudoType,
  );

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      {publishingMethods.map(([methodKey, method]) => (
        <div
          className="tw-flex"
          key={methodKey}
          data-name={`posts-composer_publishing-method_${methodKey}`}
        >
          <Radio
            size="small"
            disabled={props.disabledMethods?.includes(methodKey)}
            checked={props.value === methodKey}
            onChange={() => props.onChange(methodKey)}
          />
          <div className="tw-ml-3 tw-flex tw-flex-col tw-gap-1">
            <Button
              variant="plain"
              disabled={props.disabledMethods?.includes(methodKey)}
              className="tw-w-fit tw-text-sm tw-font-semibold tw-text-grayscale-180"
              onClick={() => props.onChange(methodKey)}
            >
              {t(
                `instagramPublishingMethods.${
                  methodKey === 'mobileApp' ? 'manual' : 'direct'
                }Publishing.label`,
              )}
              {method.isNew && (
                <Badge className="tw-ml-3" variant="gray">
                  {t('newTag')}
                </Badge>
              )}
            </Button>
            {props.value === methodKey && (
              <>
                <p className="tw-text-sm tw-text-grayscale-140">
                  {t(
                    `instagramPublishingMethods.${
                      methodKey === 'mobileApp' ? 'manual' : 'direct'
                    }Publishing.${
                      props.pseudoType === 'story' ? 'story' : 'default'
                    }Description`,
                    { postType: PseudoPostTypesUtils.label[props.pseudoType] },
                  )}
                </p>
                {method.link && (
                  <div className="tw-flex">
                    <Link to={method.link} target="_blank">
                      <Button variant="plain" className="tw-text-primary-100">
                        {t('learnMore')}
                      </Button>
                    </Link>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PostComposerPublishingMethodInstagram;
